// 主题色切换存储: 页脚色卡按钮 -> html[data-theme] + localStorage 持久化
// 三套主题仅覆盖 primary 四件套 (见 tokens.css), 全部派生色经 --u2-primary-rgb 联动
import { reactive } from 'vue'

export type ThemeKey = 'red' | 'cyan' | 'green'

export const themes: { key: ThemeKey; swatch: string }[] = [
  { key: 'red', swatch: '#E60012' },
  { key: 'cyan', swatch: '#0891B2' },
  { key: 'green', swatch: '#0E9F57' }
]

const stored = (localStorage.getItem('u2-theme') || 'red') as ThemeKey
export const themeState = reactive<{ key: ThemeKey }>({
  key: themes.some((t) => t.key === stored) ? stored : 'red'
})

export function applyTheme(key: ThemeKey) {
  themeState.key = key
  localStorage.setItem('u2-theme', key)
  if (key === 'red') {
    delete document.documentElement.dataset.theme
  } else {
    document.documentElement.dataset.theme = key
  }
}

// 启动时恢复上次选择 (main.ts 调用)
applyTheme(themeState.key)
